const WalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="20"
      viewBox="0 0 26 20"
    >
      <path
        id="Form_18"
        data-name="Form 18"
        d="M378,295a34.512,34.512,0,0,0-3.576.1,3.235,3.235,0,0,0-3.322,3.324A5.493,5.493,0,0,0,371,300v10a5.472,5.472,0,0,0,.1,1.576,3.235,3.235,0,0,0,3.324,3.322A34.659,34.659,0,0,0,378,315h12a34.413,34.413,0,0,0,3.576-.1,3.235,3.235,0,0,0,3.322-3.324A5.5,5.5,0,0,0,397,310V300a5.478,5.478,0,0,0-.1-1.576,3.235,3.235,0,0,0-3.324-3.322A34.635,34.635,0,0,0,390,295Zm0,2h12c1.5,0,2.6.006,3.35.09a1.343,1.343,0,0,1,1.56,1.558A3.831,3.831,0,0,1,395,300v1h-4a1,1,0,0,0-.219.021,3.984,3.984,0,0,0,0,7.957A1,1,0,0,0,391,309h4v1a3.833,3.833,0,0,1-.09,1.35,1.343,1.343,0,0,1-1.559,1.561c-.746.084-1.855.09-3.352.09H378c-.382,0-.668-.006-1-.008V297.007c.332,0,.617-.008,1-.008Zm-3,.07v15.859c-.105-.008-.256-.009-.35-.02a1.343,1.343,0,0,1-1.561-1.559A3.834,3.834,0,0,1,373,310V300a3.836,3.836,0,0,1,.09-1.35,1.343,1.343,0,0,1,1.559-1.561c.094-.011.246-.011.352-.02ZM391,303h4v4h-4a2,2,0,1,1,0-4Zm0,1a1,1,0,1,0,1,1A1,1,0,0,0,391,304Z"
        transform="translate(-371 -295)"
      />
    </svg>
  );
};

export default WalletIcon;
